import { Chip } from '@mui/material';
import toast from 'react-hot-toast';
import { httpRequest } from 'src/services/httpRequest';

export const columns = [
  'Township Name',
  'State',
  'Address',
  'Status',
  'Total Admins',
  'Active Admins',
  'Created Date',
  'Actions'
];

interface Field {
  townshipName: string;
  createDate: string;
  state: string;
  address: string;
  status: string;
  admins: string;
  action: string;
}

interface TownshipData {
  TownshipName: string;
  TownshipID: number;
  CreateDate: string;
  State: string;
  Address: string;
  Status: string;
  TotalAdmins: string;
  ActiveAdmins: string;
}
//Method to format date to MM/DD/YYYY
function formatDateToMMDDYYYY(timestamp: string): string {
  const date = new Date(timestamp);

  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
  const day = date.getDate().toString().padStart(2, '0');
  const year = date.getFullYear();

  return `${month}/${day}/${year}`;
}

//Method to get data from API
export const getData = async (
  url: string,
  setState: (data: Field[]) => void,
  action: (data: any) => void
) => {
  try {
    const response = await httpRequest('GET', url);
    if (response?.status === 'success') {
      const data = await response?.data?.Data;
      const Townships = data?.map((item: TownshipData) => {
        return {
          townshipName: item.TownshipName,
          state: item.State,
          address: item.Address,
          status: (
            <Chip
              label={item.Status}
              color={item.Status === 'Active' ? 'success' : 'error'}
              variant="outlined"
              sx={{ fontWeight: 'bold' }}
            />
          ),
          totalAdmins: item.TotalAdmins,
          activeAdmins: item.ActiveAdmins,
          createDate: formatDateToMMDDYYYY(item.CreateDate),
          action: action(item)
        };
      });
      setState(Townships);
    } else if (response.type === 'NETWORK_ERROR') {
    } else {
      toast.error(response?.message);
    }
  } catch (error) {
    toast.error('An error occurred while fetching permits');
    console.error('Error:', error);
  }
};
